import './index.css'
import cn from 'clsx'

import React from 'react'
import Checkbox from 'components/ui/checkbox'
import ContactSortColumn from './contact-sort-column'

const ContactHeader = ({
  columns,
  sortContacts,
  sortParam,
  sortDirection,
  selectedAll,
  onSelectAll,
  disabled,
}: {
  // TODO: Fix type
  columns: any
  sortContacts?: (...args: Array<any>) => any
  sortParam?: string | null | undefined
  sortDirection?: string | null | undefined
  selectedAll?: boolean
  onSelectAll?: ((...args: Array<any>) => any) | null | undefined
  disabled?: boolean
}): React.ReactElement<'div'> => {
  return (
    <div className={cn('ContactHeader', disabled && 'ContactHeader--disabled')}>
      {onSelectAll && (
        <div className="ContactCell ContactCell_Avatar">
          <Checkbox
            className="ContactsTable_Checkbox"
            checked={selectedAll}
            onChange={onSelectAll}
          />
        </div>
      )}
      {columns.map(header => {
        if (!header) return null
        const key = `header-${header.label}`
        const className = `ContactCell ContactCell_${header.value}`

        if (header.empty) {
          return <a key={key} className={className} />
        }

        return (
          <ContactSortColumn
            key={key}
            className={className}
            caption={header.label}
            chosen={Boolean(sortParam && header.value === sortParam)}
            sortDirection={sortDirection}
            onClick={() =>
              sortContacts && !disabled && sortContacts(header.value)
            }
          />
        )
      })}
    </div>
  )
}

export default ContactHeader
